import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'components/Tile/components';
import style from './style.css';

const CollectionTileProgressBar = ({ video }) => <ProgressBar theme={style} video={video} />;

export default CollectionTileProgressBar;

CollectionTileProgressBar.defaultProps = {
  video: null,
};

CollectionTileProgressBar.propTypes = {
  video: PropTypes.shape({}),
};
